import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import PaymentsOnHoldContext from '../Context';
import {
  StyledWrapper,
  PageButton,
  LeftArrow,
  RightArrow,
  Spaceholder
} from './Styles';

const Pagination = () => {
  const {
    currentPage,
    tradesOnPage,
    summary: { requirements },
    filterSelected,
    onClickNextPage,
    onClickPrevPage
  } = useContext(PaymentsOnHoldContext);

  const filterSelectedListLength =
    requirements[filterSelected]?.totalNumberOfTrades;

  const totalPages =
    filterSelectedListLength < tradesOnPage
      ? 1
      : Math.ceil(filterSelectedListLength / tradesOnPage);

  return (
    totalPages > 1 && (
      <StyledWrapper>
        {currentPage > 1 ? (
          <PageButton onClick={onClickPrevPage}>
            <LeftArrow />
            <FormattedMessage id="pagination.prev" />
          </PageButton>
        ) : (
          <Spaceholder />
        )}
        <FormattedMessage
          id="pagination.title"
          values={{ currentPage, totalPages }}
        />
        {currentPage < totalPages ? (
          <PageButton onClick={onClickNextPage}>
            <RightArrow />
            <FormattedMessage id="pagination.next" />
          </PageButton>
        ) : (
          <Spaceholder />
        )}
      </StyledWrapper>
    )
  );
};

export default Pagination;
